export default "__VITE_ASSET__BJTYkLGq__"